import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { httpActions, apiThunk } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { getTeamGuid } from '../../selectors/apiSelectors';

const unlinkMember = (frpId: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const resourceName = REQUEST.UNLINK_MEMBER;
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(httpActions.httpRequestMade(resourceName));
    const state = getState();
    const teamGuid = getTeamGuid(state) as string;
    const response = await makeRequest(
      `${
        config.pagesAPI
      }v1/teams/${teamGuid}/eligibleFundraiserPages/${frpId}/link`,
      {
        method: 'DELETE',
        extraHeaders: generateAuthHeaders(auth),
      },
    );
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UNLINK_MEMBER);
    }
    dispatch(httpActions.httpRequestSuccess(resourceName));
    dispatch(apiThunk.fetchMembersList());
  } catch (error) {
    dispatch(httpActions.httpRequestError(resourceName, error));
    throw error;
  }
};

export default unlinkMember;
